module.exports = __webpack_public_path__ + "img/lost_hodlmoon.gm.436fff9.png";